// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/sim_event_temperature/sim_event_temperature.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
goog.exportSymbol('proto.complimentary_actions.SimEventTemperatureActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SimEventTemperatureActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.SimEventTemperatureActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SimEventTemperatureActionArgs.displayName = 'proto.complimentary_actions.SimEventTemperatureActionArgs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SimEventTemperatureActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SimEventTemperatureActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.toObject(includeInstance, f),
temperature: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SimEventTemperatureActionArgs}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SimEventTemperatureActionArgs;
  return proto.complimentary_actions.SimEventTemperatureActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SimEventTemperatureActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SimEventTemperatureActionArgs}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTemperature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SimEventTemperatureActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SimEventTemperatureActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.serializeBinaryToWriter
    );
  }
  f = message.getTemperature();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional TriggerArgs.TimerCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.TimerCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.TimerCallback|undefined} value
 * @return {!proto.complimentary_actions.SimEventTemperatureActionArgs} returns this
*/
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SimEventTemperatureActionArgs} returns this
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float temperature = 2;
 * @return {number}
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.getTemperature = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SimEventTemperatureActionArgs} returns this
 */
proto.complimentary_actions.SimEventTemperatureActionArgs.prototype.setTemperature = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


goog.object.extend(exports, proto.complimentary_actions);
